import React, { useEffect } from 'react'
import useDraftEditor from '../../../hooks/useDraftEditor';
import { Editor } from "react-draft-wysiwyg";

export default function ExlEditEmailDraft({ setValue, value }) {

  const {
    editorState,
    setEditorState,
    editorStateToHtml
  } = useDraftEditor(value);

  const handleUpdate = (editorValue) => {
    setEditorState(editorValue);
    setValue(editorStateToHtml(editorValue));
  }

  return (
    <Editor
          editorState={editorState}
          onEditorStateChange={handleUpdate}
          wrapperClassName="wrapper-class-email-edit"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          toolbar={{
              options: ['inline',
                  'blockType',
                  'fontSize',
                  'fontFamily',
                  'list',
                  'textAlign',
                  'colorPicker',
                  'link',
                  'embedded',
                  'emoji',
                  'remove',
                  'history'],
          } }
    />
  )
}
